import React from 'react'
import PropTypes from 'prop-types'

const TopicIcon = (props) => {
  const { color = '#0284C7', classes = 'w-20' } = props
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.8C4.91898 0.8 0.8 4.91898 0.8 10C0.8 11.8393 1.33933 13.5514 2.26833 14.9882L2.35246 15.1183L1.67218 19.2H9.6L10.3767 19.1924C15.2829 18.995 19.2 14.9548 19.2 10C19.2 4.91898 15.081 0.8 10 0.8ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.3881 15.7389 19.7807 10.4025 19.992L10.3965 19.9923L9.60389 20L9.6 20H0.727816L1.5127 15.2907C0.553999 13.7559 0 11.9421 0 10Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.097 4.81194C10.3113 4.86552 10.4416 5.08269 10.3881 5.29701L7.98805 14.897C7.93447 15.1113 7.7173 15.2416 7.50298 15.1881C7.28867 15.1345 7.15836 14.9173 7.21194 14.703L9.61194 5.10298C9.66552 4.88866 9.88269 4.75836 10.097 4.81194Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.297 4.81194C13.5113 4.86552 13.6416 5.08269 13.5881 5.29701L11.1881 14.897C11.1345 15.1113 10.9173 15.2416 10.703 15.1881C10.4887 15.1345 10.3584 14.9173 10.4119 14.703L12.8119 5.10298C12.8655 4.88866 13.0827 4.75836 13.297 4.81194Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4 8.4C6.4 8.17909 6.57909 8 6.8 8H14.8C15.0209 8 15.2 8.17909 15.2 8.4C15.2 8.62091 15.0209 8.8 14.8 8.8H6.8C6.57909 8.8 6.4 8.62091 6.4 8.4Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6 11.6C5.6 11.3791 5.77909 11.2 6 11.2L14 11.2C14.2209 11.2 14.4 11.3791 14.4 11.6C14.4 11.8209 14.2209 12 14 12L6 12C5.77909 12 5.6 11.8209 5.6 11.6Z"
        fill={color}
      />
    </svg>
  )
}

TopicIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(TopicIcon)
